/**
 * English language pack - aggregate all modules
 */
import common from './common'
import menu from './menu'
import systemModule from './system'
import merchant from './merchant'
import asset from './asset'
import workflow from './workflow'
import operation from './operation'
import config from './config'
import report from './report'
import dashboard from './dashboard'
import property from './property'
import payment from './payment'
import deposit from './deposit'
import joint from './joint'
import finance from './finance'
import plan from './plan'

export default {
  ...common,
  ...menu,
  ...systemModule,
  ...merchant,
  ...asset,
  ...workflow,
  ...operation,
  ...config,
  ...report,
  ...dashboard,
  ...property,
  ...payment,
  ...deposit,
  ...joint,
  ...finance,
  ...plan,
}
